export enum ActivityType {
  ASSIGNMENT_SENT = 'ASSIGNMENT_SENT',
  ASSIGNMENT_COMPLETED = 'ASSIGNMENT_COMPLETED',
}

export type TeacherRecentActivityItem = {
  id: number;
  message: string;
  students: string;
  type: ActivityType;
  createdAt: string;
};

export type StudentRecentActivityItem = {
  id: number;
  message: string;
  studentName: string;
  completedAt: string;
};
